// extracted by css-extract-rspack-plugin
export default {"link":"link--sM1gbg6Q2eYyMVaF","logo":"logo--MAuhI4Qnarok6ne2"};